module.exports = __webpack_public_path__ + "static/media/nc.8a60305f.png";